<template>
  <div class="materiel-verifications">
    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <div>
          <h6>Vérifications</h6>
          <p class="text-muted mb-0">Liste des vérifications disponibles</p>
        </div>
        <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="storeMaterielVerif"
          :disabled="!localMateriel || !localMateriel.id || loading"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm mr-1"
          ></span>
          <i v-else class="fas fa-plus"></i>
          {{ loading ? "Ajout..." : "Ajouter une vérification" }}
        </button>
      </div>
    </div>

    <!-- Liste des vérifications existantes -->
    <div class="row">
      <div class="col-12">
        <div v-if="verifs && verifs.length > 0">
          <div
            v-for="verif in verifs"
            :key="verif.id || `verif-${Math.random()}`"
            class="mb-3"
          >
            <materiels-item-verif
              :verif="verif"
              v-if="verif && verif.id"
            ></materiels-item-verif>
          </div>
        </div>
        <div v-else class="text-muted text-center py-4">
          <i class="fas fa-clipboard-check fa-2x mb-2"></i>
          <p class="mb-0">Aucune vérification enregistrée pour ce matériel</p>
          <small>Cliquez sur "Ajouter une vérification" pour commencer</small>
        </div>
      </div>
    </div>

    <!-- Modal pour ajouter/éditer une vérification -->
    <div
      v-if="showVerificationModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0,0,0,0.5);"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{
                editingVerification
                  ? "Modifier la vérification"
                  : "Ajouter une vérification"
              }}
            </h5>
            <button
              type="button"
              class="btn-close"
              @click="closeVerificationModal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="saveVerification">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Date de vérification *</label>
                    <input
                      v-model="currentVerification.date_verification"
                      type="date"
                      class="form-control"
                      required
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Type de vérification</label>
                    <select
                      v-model="currentVerification.type_verification"
                      class="form-control"
                    >
                      <option value="">Sélectionner un type</option>
                      <option value="Vérification périodique"
                        >Vérification périodique</option
                      >
                      <option value="Maintenance préventive"
                        >Maintenance préventive</option
                      >
                      <option value="Maintenance corrective"
                        >Maintenance corrective</option
                      >
                      <option value="Contrôle réglementaire"
                        >Contrôle réglementaire</option
                      >
                      <option value="Étalonnage">Étalonnage</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Résultat</label>
                    <select
                      v-model="currentVerification.resultat"
                      class="form-control"
                    >
                      <option value="">Sélectionner un résultat</option>
                      <option value="Conforme">Conforme</option>
                      <option value="Non conforme">Non conforme</option>
                      <option value="Conforme avec réserves"
                        >Conforme avec réserves</option
                      >
                      <option value="En attente">En attente</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Organisme</label>
                    <input
                      v-model="currentVerification.organisme"
                      type="text"
                      class="form-control"
                      placeholder="Ex: APAVE, BUREAU VERITAS..."
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>N° de certificat</label>
                    <input
                      v-model="currentVerification.certificat_numero"
                      type="text"
                      class="form-control"
                      placeholder="Numéro du certificat"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group mb-3">
                    <label>Prochaine échéance</label>
                    <input
                      v-model="currentVerification.prochaine_echeance"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-3">
                    <label>Commentaires</label>
                    <textarea
                      v-model="currentVerification.commentaires"
                      class="form-control"
                      rows="3"
                      placeholder="Observations, remarques..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="closeVerificationModal"
            >
              Annuler
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveVerification"
            >
              {{ editingVerification ? "Modifier" : "Ajouter" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import MaterielsItemVerif from "@/components/materiels/MaterielsItemVerif.vue";

export default {
  components: {
    MaterielsItemVerif
  },
  props: {
    materiel: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      internalMateriel: {},
      loading: false,
      showVerificationModal: false,
      editingVerification: null,
      currentVerification: {
        date_verification: "",
        type_verification: "",
        resultat: "",
        organisme: "",
        certificat_numero: "",
        prochaine_echeance: "",
        commentaires: ""
      }
    };
  },
  computed: {
    ...mapMultiRowFields("materiel", ["materielsVerifs"]),

    localMateriel: {
      get() {
        return Object.keys(this.internalMateriel).length > 0
          ? this.internalMateriel
          : this.materiel || {};
      },
      set(value) {
        this.internalMateriel = { ...value };
        this.updateMateriel();
      }
    },
    verifs: function() {
      // Filtrer les vérifications pour ce matériel
      if (
        !this.materielsVerifs ||
        !this.localMateriel ||
        !this.localMateriel.id
      ) {
        return [];
      }
      return this.materielsVerifs.filter(
        verif => verif.materiel_id === this.localMateriel.id
      );
    }
  },
  watch: {
    materiel: {
      handler(newVal) {
        if (newVal) {
          this.internalMateriel = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions({
      _storeMaterielVerif: "materiel/createMaterielVerif",
      _deleteMaterielVerif: "materiel/deleteMaterielVerif",
      _getAll: "materiel/getAll"
    }),
    updateMateriel() {
      this.$emit("update", this.internalMateriel);
    },
    storeMaterielVerif() {
      if (!this.localMateriel || !this.localMateriel.id) {
        console.error("Veuillez d'abord enregistrer le matériel");
        return;
      }

      this.loading = true;
      this._storeMaterielVerif({
        id: this.localMateriel.id // L'API attend 'id', pas 'materiel_id'
      })
        .then(() => {
          console.log("Vérification ajoutée avec succès");
          // Recharger toutes les données pour avoir les nouvelles vérifications
          return this._getAll();
        })
        .then(() => {
          // Les vérifications sont maintenant rechargées
        })
        .catch(error => {
          console.error("Erreur lors de l'ajout de la vérification:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeVerificationModal() {
      this.showVerificationModal = false;
      this.editingVerification = null;
      this.currentVerification = {
        date_verification: "",
        type_verification: "",
        resultat: "",
        organisme: "",
        certificat_numero: "",
        prochaine_echeance: "",
        commentaires: ""
      };
    },
    saveVerification() {
      // TODO: Implémenter la sauvegarde/modification des vérifications
      console.log("Sauvegarde de la vérification:", this.currentVerification);
      this.closeVerificationModal();
    }
  }
};
</script>

<style scoped>
.materiel-verifications {
  padding: 20px;
}
h6 {
  color: #333;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 0.5rem;
}
</style>
